<template>
    <div class="menu_wrap" :class="{ flex_center: user.userInfo.clfCd !== 99 }">
        <div class="menu_list">
            <span class="menu_title">플랫폼</span>
            <template v-for="item in platform.list">
                <div
                    class="menu_tab shadow"
                    v-if="!item.isAdmin || (item.isAdmin && user.userInfo.clfCd === 99)"
                    :class="{
                        active: global.selectMenu === item.idx,
                        small: global.selectMenu !== 0 && global.selectMenu !== 5,
                        disabled: item.isDisabled,
                    }"
                    @click="movePage(item)"
                >
                    <div class="menu_icon" v-if="global.selectMenu === 0 || global.selectMenu === 5">
                        <img :src="global.selectMenu === item.idx ? item.icon.white : item.icon.blue" />
                    </div>
                    <div class="menu_name">
                        {{ item.title }}
                    </div>
                </div>
            </template>
        </div>
        <div class="menu_list">
            <span class="menu_title">왓쳐봇</span>
            <template v-for="item in watcherBot.list">
                <div
                    class="menu_tab shadow"
                    v-if="!item.isAdmin || (item.isAdmin && user.userInfo.clfCd === 99)"
                    :class="{
                        active: global.selectMenu === item.idx,
                        small: global.selectMenu !== 0 && global.selectMenu !== 5,
                        disabled: item.isDisabled,
                    }"
                    @click="movePage(item)"
                >
                    <div class="menu_icon" v-if="global.selectMenu === 0 || global.selectMenu === 5">
                        <img :src="global.selectMenu === item.idx ? item.icon.white : item.icon.blue" />
                    </div>
                    <div class="menu_name">
                        {{ item.title }}
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import { globalStore, reactive, router, userStore } from "@/BaseComponent";

    interface Menu {
        idx: number;
        title: string;
        link: string;
        isAdmin: boolean;
        isDisabled?: boolean;
        icon: {
            blue: string;
            white: string;
        };
    }

    export default {
        setup() {
            const user = userStore();
            const global = globalStore();
            const menu = reactive({});

            const platform = reactive({
                list: [
                    {
                        idx: 0,
                        title: "검색",
                        link: "/",
                        isAdmin: false,
                        icon: { blue: require("@/assets/common/search_bu.png"), white: require("@/assets/common/search_wh.png") },
                    },
                    {
                        idx: 1,
                        title: "검색 관리",
                        link: "/search/history",
                        isAdmin: false,
                        icon: { blue: require("@/assets/common/result_bu.png"), white: require("@/assets/common/result_wh.png") },
                    },
                    {
                        idx: 2,
                        title: "모니터링",
                        link: "/monitoring",
                        isAdmin: false,
                        icon: { blue: require("@/assets/common/moniterring_bu.png"), white: require("@/assets/common/moniterring_wh.png") },
                    },
                    {
                        idx: 3,
                        title: "통계",
                        link: "/statistics",
                        isAdmin: false,
                        icon: { blue: require("@/assets/common/statistics_bu.png"), white: require("@/assets/common/statistics_wh.png") },
                    },
                    {
                        idx: 4,
                        title: "계정관리",
                        link: "/management/account",
                        isAdmin: true,
                        icon: { blue: require("@/assets/common/userManage_bu.png"), white: require("@/assets/common/userManage_wh.png") },
                    },
                ] as Menu[],
            });

            const watcherBot = reactive({
                list: [
                    // {
                    //     idx: 5,
                    //     title: "검색",
                    //     link: "/watcherbot/search",
                    //     isAdmin: false,
                    //     icon: { blue: require("@/assets/common/search_bu.png"), white: require("@/assets/common/search_wh.png") },
                    // },
                    {
                        idx: 6,
                        title: "검색 관리",
                        link: "/watcherbot/result",
                        isAdmin: false,
                        icon: { blue: require("@/assets/common/result_bu.png"), white: require("@/assets/common/result_wh.png") },
                    },
                    {
                        idx: 7,
                        title: "AI왓쳐봇",
                        link: "/ai/watcher_bot",
                        isAdmin: false,
                        icon: {
                            blue: require("@/assets/common/searchResult_bu.png"),
                            white: require("@/assets/common/searchResult_wh.png"),
                        },
                    },
                    {
                        idx: 8,
                        title: "통계",
                        link: "#",
                        isAdmin: false,
                        isDisabled: true,
                        icon: { blue: require("@/assets/common/statistics_bu.png"), white: require("@/assets/common/statistics_wh.png") },
                    },
                ] as Menu[],
            });

            const movePage = (item: Menu) => {
                if (item.isDisabled) return;
                global.setSelectMenu(item.idx);
                router.push(item.link);
            };

            return {
                global,
                user,
                menu,
                movePage,
                platform,
                watcherBot,
            };
        },
    };
</script>

<style>
    .menu_title {
        min-width: 55px;
        font-size: 18px;
        font-weight: bold;
        color: #757575;
    }
    .menu_tab.shadow.disabled {
        background-color: #c7c7c7;
        cursor: no-drop;
    }
</style>
